import styled from "styled-components";

import { ReactComponent as Accept } from "../../../styles/icon/accept.svg"
import { ReactComponent as Decline } from "../../../styles/icon/decline.svg"
import { ReactComponent as Close } from "../../../styles/icon/close.svg"
import { ReactComponent as Menu } from "../../../styles/icon/menu.svg"
import { ReactComponent as Account } from "../../../styles/icon/account_circle.svg"
import { ReactComponent as BackArrow } from "../../../styles/icon/backArrow.svg"
import { ReactComponent as CirclePlus } from "../../../styles/icon/circle_plus.svg"
import { ReactComponent as PersonPlus } from "../../../styles/icon/person_plus.svg"
import { ReactComponent as CloseApplication } from "../../../styles/icon/closeApplication.svg"
import { ReactComponent as Checkmark } from "../../../styles/icon/toast_checkmark.svg"
import { ReactComponent as InfoExclamation} from "../../../styles/icon/info_exclamation.svg"

export const AcceptIcon = styled(Accept)`
  height: 15px;
  width: 15px;
  padding: 5px;
`;

export const DeclineIcon = styled(Decline)`
  height: 15px;
  width: 15px;
  padding: 5px;
`;

export const InfoTextDeclineIcon = styled(Decline)`
  height: 13px;
  width: 13px;
  padding: 10px;
  fill: ${props => props.theme.brandColor1};
  float:right;
`;

export const CloseIcon = styled(Close)`
  height: 15px;
  width: 15px;
  padding: 5px;
  margin-left: auto;
  cursor: pointer;
`;

export const MenuIcon = styled(Menu)`
  height: 25px;
  width: 25px;
  cursor: pointer;
  float: right;
  margin: 20px;
  position: absolute;
  top: 0;
  right: 0;
  > path {
    fill: ${props => props.theme.brandColor1}
  }
`;

export const AccountIcon = styled(Account)`
  cursor: pointer;
  float:right;
  margin-right:33px;
  margin-top: 30px;
  > path {
    fill: ${props => props.theme.brandColor1}
  }
`;

export const BackArrowIcon = styled(BackArrow)`
  height: 45px;
  width: 45px;
  position: absolute;
  cursor: pointer;
  color: ${props => props.theme.brandColor1};
  @media screen and (max-width: ${(props) => props.theme.mobileMenuBreakpoint}px) {
      top: 70px;
  };
  > path {
    fill: ${props => props.theme.brandColor1};
  }
`;

export const BackArrowCreateApplicationIcon = styled(BackArrow)`
  height: 48px;
  width: 48px;
  position: relative;
  cursor: pointer;
  > path {
    fill: ${props => props.theme.brandColor1};
  }
`;

export const EnterpriseApplicationCirclePlusIcon = styled(CirclePlus)`
  height: 75px;
  width: 75px;
  position: relative;
  bottom: 75px;
  > path {
    fill: ${props => props.theme.brandColor1}
  }
  > circle {
    stroke: ${props => props.theme.brandColor1}
  }
`;

export const CirclePlusIcon = styled(CirclePlus)`
  height: 75px;
  width: 75px;
  position: relative;
  bottom: 24px;
  > path {
    fill: ${props => props.theme.brandColor1}
  }
  > circle {
    stroke: ${props => props.theme.brandColor1}
  }
`;

export const PersonPlusIcon = styled(PersonPlus)`
  height: 75px;
  width: 75px;
  position: relative;
  bottom: 75px;
  > path {
    fill: ${props => props.theme.brandColor1}
  }
`;

export const CloseApplicationIcon = styled(CloseApplication)`
  height: 28px;
  width: 28px;
  cursor: pointer;
  position: absolute;
  right: 19px;
  top: 19px;
  @media screen and (max-width: 600px) {
    right: 10px;
    }
`;

export const CheckmarkIcon = styled(Checkmark)`
  width: 43px;
  height: 43px;
  margin: 0;
  position: sticky;
  top: 40%;
`;

export const InfoIcon = styled(InfoExclamation)` 
    @media screen and (max-width: 850px) {
      position: absolute;
      top: 208px;
      height: 27px;
      display: flex;
      width: 100%;
      justify-content: center;
    }
    @media screen and (min-width: 851px) {
      position: absolute;
      width: 34px;
      left: 18px;
      top: 0;
      margin: auto 0;
      bottom: 0;
    }
`;

export const InfoForPersonalApplicationIcon = styled(InfoExclamation)` 
    @media screen and (max-width: 850px) {
      position: absolute;
      top: 377px;
      height: 27px;
      display: flex;
      width: 100%;
      justify-content: center;
    }
    @media screen and (min-width: 851px) {
      position: absolute;
      width: 34px;
      left: 18px;
      top: 0;
      margin: auto 0;
      bottom: 0;
    }
`;